import * as R from 'ramda';
import memoizee from 'memoizee';

import { getItemsArray } from 'redux/hor/module/selectors';

export const getUnits = memoizee(
  R.compose(
    R.map(i => ({
      label: i.custom_наименование,
      value: i.key,
    })),
    getItemsArray,
  ),
  { max: 1 },
);
